import PropTypes from 'prop-types';
import './Header.scss';

export const Header = ({ title, subtitle, imgUrl }) => (
  <header className="Checkout-Header">
    {imgUrl && (
      <div className="Checkout-Header-logo">
        <img src={imgUrl} alt="logo" />
      </div>
    )}
    {title && <h1 className="Checkout-Header-title">{title}</h1>}
    {subtitle && <p className="Checkout-Header-subtitle">{subtitle}</p>}
  </header>
);

Header.displayName = 'Header';
Header.propTypes = {
  imgUrl: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};
